module.exports = __webpack_public_path__ + "img/company-logo.32f258fc.png";